import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BearerTokenKeyName } from "../constants/strings";
import { AuthenticationService } from "../services/authentication/authentication.service";
import { LocalStoreManagerService } from "../services/local-store-manager-service/local-store-manager.service";
import { SessionIdService } from "../services/session-id-service/session-id.service";

@Injectable()
export class BearerTokenInterceptor implements HttpInterceptor {
    constructor(private localStoreManager: LocalStoreManagerService,
        private authenticationService: AuthenticationService,
        private sessionIdService: SessionIdService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const bearerToken = this.localStoreManager.getData(BearerTokenKeyName);
        let windowsAuthRequest = this.authenticationService.getIsWindowsAuthRequest();
        let anonymousReques = this.authenticationService.getIsAnonymousRequest();

        req = req.clone({
            ...(windowsAuthRequest && { withCredentials: true }),
            setHeaders: {
                ...(bearerToken && !windowsAuthRequest && !anonymousReques && { 'OneTwoThreeAuth': bearerToken }),
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
                'OneTwoThreeSessionId': this.sessionIdService.getSessionId()
            }
        });

        return next.handle(req);
    }
}
